import * as Sentry from '@sentry/angular';
import packageInfo from '../../../../package.json';
import { environment } from '@env/environment';

let sentryInitialized = false;

/**
 * Initializes the Sentry browser SDK once when a DSN is available.
 * Called after AppConfigService loads config / authenticated key `App.Web.Sentry.DSN`, and from bootstrap (no-op until DSN exists).
 */
export function initSentryFromDsn(dsn: string | undefined | null): void {
    const trimmed = dsn?.trim();
    if (!trimmed || sentryInitialized) {
        return;
    }
    sentryInitialized = true;

    Sentry.init({
        dsn: trimmed,
        environment: environment.production ? 'production' : 'development',
        release: `cropmap@${packageInfo.version}`,
        integrations: [Sentry.browserTracingIntegration()],
        tracePropagationTargets: [
            'localhost',
            /^https:\/\/api\.doktar\./,
            /^https:\/\/app\.cropmap\.doktar\.cc\//,
            /^https:\/\/app\.cropmap\.com\//,
        ],
        tracesSampleRate: environment.production ? 0.1 : 1.0,
        ignoreErrors: [
            'Service Worker registration failed',
            'The FetchEvent for',
            'The FetchEvent',
            'navigator.serviceWorker',
            /Extension context invalidated/,
            /Non-Error promise rejection captured/,
            /NetworkError/,
            /Failed to fetch/,
        ],
        beforeSend(event) {
            if (!environment.production) {
                console.log('Sentry Event:', event);
            }
            return event;
        },
        initialScope: {
            tags: {
                component: 'app',
                version: packageInfo.version,
            },
            contexts: {
                app: {
                    name: 'CropMap',
                    version: packageInfo.version,
                },
            },
        },
    });
}
